import _ from 'lodash';

import changeComposition from 'actions/composition/lib/change_composition';
import CloseModal from 'actions/modal/close_modal';
import CustomerView from 'models/location/customer_view';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import removeComposition from 'actions/composition/lib/remove_composition';

export default class ClearCurrentComposition {
  constructor(context) {
    this.context = context;
  }

  run() {
    // HACK: If a modal is still open after we close the composition, then the gray overlay will remain.
    //       This isn't the proper fix, see https://jira.mertslounge.ca/browse/DEV-8253
    this.context.executeAction(CloseModal);
    let currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof CustomerView)) {
      throw new Error(
        `cannot clear current composition when current location is [${currentLocation &&
          currentLocation.constructor.name}]`
      );
    }

    this.context.stores.selectedKbItem.set(null);

    let currentCompositionId = currentLocation.currentCompositionId;
    let composition = getCompositionsStore(this.context).findBy({ id: currentCompositionId });

    if (composition) {
      this.focusPreviousComposition(currentLocation, composition);
      removeComposition(this.context, composition);
    }

    getCompositionsStore(this.context).clearErrorsForNew();
  }

  // set the composition to the previous composition for the conversation
  focusPreviousComposition(currentLocation, composition) {
    let prevComposition = this.getPreviousComposition(composition);
    changeComposition(this.context, prevComposition);
  }

  getPreviousComposition(composition) {
    let compositions = getCompositionsStore(this.context).findAll({ conversationId: composition.conversationId });
    let index = _.findIndex(compositions, { id: composition.id });

    if (index === 0) {
      // if closing the first composition, open the next one
      index = 1;
    } else {
      // open the previous one
      index -= 1;
    }

    return compositions[index];
  }
}

ClearCurrentComposition.actionName = 'ClearCurrentComposition'; // for tracking actions in analytics



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/close_current_composition.js